import ProductTemplateSimple from "../templates/product-template-simple";
import { Eatonacb } from '../data/products'
function ProductEatonAcb() {
    return (
        <>
            <ProductTemplateSimple data = {Eatonacb}/>
        </>
    )
}

export default ProductEatonAcb;